import { render, staticRenderFns } from "./AddTargetDayWiseDataModal.vue?vue&type=template&id=1f370f78&scoped=true"
import script from "./AddTargetDayWiseDataModal.vue?vue&type=script&lang=js"
export * from "./AddTargetDayWiseDataModal.vue?vue&type=script&lang=js"
import style0 from "./AddTargetDayWiseDataModal.vue?vue&type=style&index=0&id=1f370f78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f370f78",
  null
  
)

export default component.exports